import React, { useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Film } from 'lucide-react';
import './FilmStrip.css';

const FilmStrip = ({
                       images,
                       maxImages = 4,
                       onImageClick,
                       width = window.innerWidth,
                       transform = 'none',
                       showNavButtons = false,
                       onNavClick
                   }) => {
    const filmstripRef = useRef(null);

    // Pass the filmstrip width to parent when it changes
    useEffect(() => {
        if (filmstripRef.current) {
            const filmstripWidth = filmstripRef.current.scrollWidth;
            if (onNavClick) {
                onNavClick.setFilmstripWidth?.(filmstripWidth);
            }
        }
    }, [images, onNavClick]);

    // Show video icon on thumbnails
    const MediaPreview = ({ item }) => {
        const isVideo = item.type === 'video';
        return (
            <div className="media-preview-container">
                <img
                    src={item.thumbnailPath || item}
                    alt={isVideo ? 'Video thumbnail' : `Slide`}
                    className="filmstrip-image"
                />
                {isVideo && (
                    <div className="video-indicator">
                        <Film size={16} />
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="filmstrip-container" style={{ background: 'none' }}>
            {showNavButtons && (
                <>
                    <button
                        className="nav-button nav-button-left"
                        onClick={() => onNavClick && onNavClick(1)}
                    >
                        <ChevronLeft size={32} />
                    </button>
                    <button
                        className="nav-button nav-button-right"
                        onClick={() => onNavClick && onNavClick(-1)}
                    >
                        <ChevronRight size={32} />
                    </button>
                </>
            )}

            <div className="filmstrip-wrapper">
                <div
                    ref={filmstripRef}
                    className="filmstrip"
                    style={{
                        transform: transform !== 'none' ? `translateX(${transform}px)` : 'none',
                        display: 'flex',
                        gap: '0.5rem'
                    }}
                >
                    {images.slice(0, showNavButtons ? images.length : maxImages).map((image, index) => (
                        <div
                            key={index}
                            className="filmstrip-slide"
                            onClick={() => onImageClick(image, index)}
                        >
                            <MediaPreview item={image} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FilmStrip;